import {useMemo} from "react";
import {useQuery} from "react-query";
import {Dayjs} from "dayjs";
import {queryKeys} from "../Constant/QueryKeys";
import {REPO} from "../Repository/repo";

/**
 * 대한민국 공휴일 조회 훅.
 * - 서버(/system/holidays)가 Google ICS 를 48h 캐시하므로 클라는 길게 캐시.
 * - date("YYYY-MM-DD") → 공휴일명 Map 으로 isHoliday / holidayName 제공.
 */
const useHolidays = () => {
    const {data} = useQuery(
        queryKeys.holidays,
        async () => {
            const res = await REPO.System.Holidays()
            return res.data.holidays
        },
        {
            staleTime: 1000 * 60 * 60 * 12, // 12h
            cacheTime: 1000 * 60 * 60 * 24, // 24h
        }
    )

    const nameByDate = useMemo(() => {
        const map = new Map<string, string>()
        ;(data || []).forEach(h => map.set(h.date, h.name))
        return map
    }, [data])

    const isHoliday = (date: Dayjs): boolean => nameByDate.has(date.format("YYYY-MM-DD"))
    const holidayName = (date: Dayjs): string | undefined => nameByDate.get(date.format("YYYY-MM-DD"))

    return {isHoliday, holidayName}
}

export default useHolidays
